/* ==========================================================================
   ATÖLYE — güvence rozetleri: tooltip davranışı + YERLEŞTİRME

   İki iş var.

   1) DOKUNMATİK: telefonda hover yoktur, yalnızca CSS'e bırakılan bir
      açıklama ziyaretçilerin çoğuna hiç görünmez. Bir rozete dokunmak açar,
      tekrar dokunmak kapatır, dışarı dokunmak veya ESC kapatır.

   2) YERLEŞTİRME (2026-08-21): balon rozetin sol kenarından açılıyor ve
      genişliği içeriğinden geliyor. Rozetler flex-wrap ile dizildiği için
      hangi rozetin ekranın hangi kenarına yakın düştüğü ÖNCEDEN BİLİNEMEZ —
      eskiden `nth-child(n + 3)` ile "son ikisi sağdadır" varsayılıyordu ve
      dar ekranda ızgara 2x2'ye düşünce bu varsayım çöküyordu: ölçümde
      "ÜCRETSİZ KARGO" balonu sayfanın solundan 129px, "TAKSİT İMKANI"
      sağından 89px taşıyordu.

      Taşmanın ikinci ve daha sinsi sonucu: balon KAPALIYKEN de layout'ta
      yer kaplıyor (visibility: hidden gizler ama yerinden etmez), yani
      sayfanın kendisi 89px yatay kaydırılabilir hale geliyordu. Kullanıcı
      bunu "mobilde sayfa kayıyor" diye gördü; sebebi hiç açılmamış bir
      tooltip'ti.

      Çözüm ölçmek: her balonun nereye düştüğüne bakıp ekrana geri çeken
      yatay düzeltmeyi --guv-kaydir olarak yazıyoruz. Kapalı balonlar da
      ölçülüyor, taşma o yüzden hiç oluşmuyor.
   ========================================================================== */

(() => {
  "use strict";

  /* Balonun ekran kenarına bırakacağı en küçük pay. */
  const KENAR = 8;

  /**
   * Balonun viewport'taki yerini transform'DAN BAĞIMSIZ ölçer.
   *
   * getBoundingClientRect kullanmıyoruz: balonun transform'u hem açılış
   * animasyonunu hem bizim düzeltmemizi taşıyor ve transition'a bağlı.
   * Rect ile ölçmek "kendi yazdığımız kaydırmayı tekrar ölçmek" olurdu —
   * düzeltme her ölçümde birikirdi. offsetLeft/offsetWidth transform'u
   * görmez, bu yüzden ölçüm idempotenttir.
   */
  const yerlestir = (tip) => {
    const kok = tip.offsetParent;
    if (!kok) return; // display:none — ölçülecek bir şey yok

    const kr = kok.getBoundingClientRect();
    const sol = kr.left + tip.offsetLeft;
    const sag = sol + tip.offsetWidth;
    const vw = document.documentElement.clientWidth;

    let d = 0;
    if (sag > vw - KENAR) d = -(sag - (vw - KENAR));
    if (sol + d < KENAR) d = KENAR - sol;

    if (Math.abs(d) < 0.5) tip.style.removeProperty("--guv-kaydir");
    else tip.style.setProperty("--guv-kaydir", d.toFixed(1) + "px");
  };

  const hepsiniYerlestir = () =>
    document.querySelectorAll("[data-atl-guvence] .atl-guv__tip").forEach(yerlestir);

  const kur = (kok) => {
    if (kok.dataset.atlGuvHazir === "1") return;
    kok.dataset.atlGuvHazir = "1";

    const hucreler = [...kok.querySelectorAll(".atl-guv__cell")];
    if (!hucreler.length) return;

    const hepsiniKapat = (haric) => {
      hucreler.forEach((h) => {
        if (h === haric) return;
        h.classList.remove("is-open");
        h.querySelector(".atl-guv__btn")?.setAttribute("aria-expanded", "false");
      });
    };

    hucreler.forEach((hucre) => {
      const btn = hucre.querySelector(".atl-guv__btn");
      const tip = hucre.querySelector(".atl-guv__tip");
      if (!btn) return;

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const acik = hucre.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", acik ? "true" : "false");
        hepsiniKapat(hucre);
        // Açılış anında yeniden ölç: araya giren bir düzen değişikliği
        // (font yüklenmesi, varyant değişimi) balonu kaydırmış olabilir.
        if (acik && tip) yerlestir(tip);
      });

      // Masaüstünde balon hover ile açılıyor; ölçüm sayfa yüklenirken zaten
      // yapıldı ama fare değdiğinde bir kez daha teyit etmek bedava.
      if (tip) hucre.addEventListener("pointerenter", () => yerlestir(tip));
    });

    // Dışarı dokunuş kapatır. Belge seviyesinde dinliyoruz çünkü kapanma
    // sayfanın herhangi bir yerine dokununca olmalı.
    document.addEventListener("click", () => hepsiniKapat(null));

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") hepsiniKapat(null);
    });

    hepsiniYerlestir();
  };

  const baslat = () => {
    document.querySelectorAll("[data-atl-guvence]").forEach(kur);
    hepsiniYerlestir();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", baslat, { once: true });
  } else {
    baslat();
  }

  // Yazı tipi geç gelirse balonun genişliği değişir; önceki ölçüm bayatlar.
  if (document.fonts?.ready) document.fonts.ready.then(hepsiniYerlestir);

  // Ekran döndürme / pencere boyutu: kaydırma miktarı viewport'a bağlı.
  let z;
  addEventListener("resize", () => {
    clearTimeout(z);
    z = setTimeout(hepsiniYerlestir, 120);
  });

  // Tema düzenleyicide bölüm yeniden yüklenince bağlanmayı tekrarla.
  document.addEventListener("shopify:section:load", baslat);
})();
